module.exports = __webpack_public_path__ + "static/media/nima_talking_dai.43d93b58.gif";